jQuery(document).ready(function($) {
	$.loadmore = {
		action : false,
		offset : 6,

		init: function() {
			$(document).on('click', '.m-button__more', function(e) {
				$.loadmore.action = 'loadMoreItems';
				$.loadmore.offset += 6; // display posts per page which follow the (offset) posts, not greater than posts_per_page
				
				$.loadmore.post(e);
			});
		},

		post: function(e) {
			var ajaxurl = ajaxobj.ajaxurl;
			var data = {
				'action'      : 'loadMedia',
				'offset'      : $.loadmore.offset,
				'itemType'	  : $('.js-mediabox__container').data('type')
			};

			jQuery.post(ajaxurl, data, function(response) {
			}).done(function(response) {
				switch ($.loadmore.action) {
					case 'loadMoreItems':
						$.loadmore.loadMoreItems(response);
						$.loadmore.triggerEvent();
						break;
				}
			});
		},

		triggerEvent: function() {
			setTimeout(() => {
				var event = new Event('loadMoreComplete');
				document.dispatchEvent(event);	
			}, 300);
		},

		loadMoreItems: function(response) {
			$('.m-button__more__wrapper', '.js-mediabox__container').remove();
			$('.js-mediabox__container').append($('div[data-itemtype="mediabox"]', response));

			if ($('.m-button__more__wrapper', response).length !== 0) {
				$('.js-mediabox__container').append($('.m-button__more__wrapper', response));
			}
		},

	};

});